import React, { useState, useEffect } from 'react';

const LoveCounter: React.FC = () => {
    const [timeElapsed, setTimeElapsed] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const startDate = new Date('2024-07-19T10:00:00');

        const updateTimer = () => {
            const now = new Date();
            const difference = now.getTime() - startDate.getTime();

            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            setTimeElapsed({ days, hours, minutes, seconds });
        };

        updateTimer();
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="bg-gradient-to-r from-pink-100 to-purple-100 py-8 px-4">
            <div className="container mx-auto text-center">
                <h2 className="text-3xl font-bold text-pink-600 mb-6">
                    💕 Đồng hồ tình yêu 💕
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
                    <div className="bg-white rounded-lg shadow-lg p-4">
                        <div className="text-4xl font-bold text-pink-500">{timeElapsed.days}</div>
                        <div className="text-sm text-gray-600">Ngày</div>
                    </div>
                    <div className="bg-white rounded-lg shadow-lg p-4">
                        <div className="text-4xl font-bold text-purple-500">{timeElapsed.hours}</div>
                        <div className="text-sm text-gray-600">Giờ</div>
                    </div>
                    <div className="bg-white rounded-lg shadow-lg p-4">
                        <div className="text-4xl font-bold text-pink-400">{timeElapsed.minutes}</div>
                        <div className="text-sm text-gray-600">Phút</div>
                    </div>
                    <div className="bg-white rounded-lg shadow-lg p-4">
                        <div className="text-4xl font-bold text-purple-400">{timeElapsed.seconds}</div>
                        <div className="text-sm text-gray-600">Giây</div>
                    </div>
                </div>
                {/* <p className="text-gray-600 mt-4 text-sm">
                    Kể từ ngày 19 tháng 7 năm 2024 ❤️
                </p> */}
            </div>
        </div>
    );
};

export default LoveCounter; 